import React, { useState } from "react";
interface Section {
  id: string;
  title: string;
}

const Navbar = ({
  sections,
  primaryColor,
  accentColor,
  logoUrl,
}: {
  sections: Section[];
  primaryColor?: string;
  accentColor?: string;
  logoUrl?: string;
}) => {
  return (
    <div
      id="top-nav"
      style={{
        zIndex: "1000",
        top: "80px",
        width: "auto",
        height: "92px",
        padding: "0 40px",
        background: "#fff",
        borderBottom: "1px solid #ccc",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
      }}
    >
      <div>
        <img src={logoUrl} alt="Company Logo" />
      </div>
      <a
        href="#contact"
        rel="noopener noreferrer"
        style={{
          padding: "10px",
          backgroundColor: accentColor,
          border: "none",
          borderRadius: "8px",
          fontSize: "16px",
          cursor: "pointer",
          color: "#fff",
          width: "101px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textDecoration: "none",
        }}
      >
        Contact
      </a>
    </div>
  );
};

const LandingPageBody = ({
  isForSharing = false,
  primaryColor,
  accentColor,
  logoUrl,
}: {
  isForSharing?: boolean;
  primaryColor?: string;
  accentColor?: string;
  logoUrl?: string;
}) => {
  const [sections, setSections] = useState<Section[]>([
    { id: "main-section", title: "Main Section" },
    { id: "who-we-are", title: "Who We Are" },
    { id: "what-we-offer", title: "What We Offer" },
    { id: "values-principles", title: "Values & Principles" },
    { id: "testimonials", title: "Testimonials" },
    { id: "our-service", title: "Our Services" },
  ]);

  const updateSectionTitle = (id: string, newTitle: string) => {
    setSections((prev) =>
      prev.map((section) =>
        section.id === id ? { ...section, title: newTitle } : section
      )
    );
  };

  return (
    <div>
      <Navbar
        sections={sections}
        primaryColor={primaryColor}
        accentColor={accentColor}
        logoUrl={logoUrl}
      />
    </div>
  );
};

export default LandingPageBody;
